var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e()]), _vm._m(0), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    staticClass: "required",
    attrs: {
      "id": 'zdanenie_minuly_rok',
      "init-value": _vm.form.zdanenie_minuly_rok,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Bol príjem zdanený?',
      "required": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'zdanenie_minuly_rok');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "trzby"
    }
  }, [_vm._v("Ročné príjmy / obrat")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.minulorocny_obrat,
      expression: "form.minulorocny_obrat",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "trzby",
      "data-name": "trzby",
      "required": "",
      "id": "trzby"
    },
    domProps: {
      "value": _vm.form.minulorocny_obrat
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "minulorocny_obrat", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(1), _c('div', {
    staticClass: "dropdown-input-custom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.pausalne_vydavky,
      expression: "form.pausalne_vydavky"
    }],
    staticClass: "required",
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.pausalne_vydavky
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "pausalne_vydavky", $event.target.value);
      }
    }
  }), _c('dropdown-select', {
    staticClass: "required",
    attrs: {
      "id": 'pausalne_vydavky',
      "init-value": _vm.form.pausalne_vydavky,
      "options": _vm.lastYearExpenses,
      "normal": "",
      "name": 'Výdavky? (paušálne / reálne, nájdete na str. 4)'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'pausalne_vydavky');
      }
    }
  })], 1), _vm._m(2), !_vm.form.pausalne_vydavky ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vydavky"
    }
  }, [_vm._v("Výdavky")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.minulorocne_vydavky,
      expression: "form.minulorocne_vydavky",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "vydavky",
      "data-name": "vydavky",
      "required": "",
      "id": "vydavky"
    },
    domProps: {
      "value": _vm.form.minulorocne_vydavky
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "minulorocne_vydavky", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), !_vm.form.pausalne_vydavky ? _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" VI. oddiel, riadok 40 – výdavky prenesené z tabuľky č. 1, stĺpec 2, riadok 10. ")]) : _vm._e(), _c('div', {
    staticClass: "dropdown-input-custom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.lastYearExpenses,
      expression: "form.lastYearExpenses"
    }],
    staticClass: "required",
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.lastYearExpenses
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "lastYearExpenses", $event.target.value);
      }
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": 'tradesman_vydavky',
      "init-value": _vm.form.lastYearExpenses,
      "options": _vm.insuranceLastYear,
      "normal": "",
      "name": 'Ako chcete zadať poistné'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'lastYearExpenses');
      }
    }
  })], 1), _vm.form.lastYearExpenses !== 'other' ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "poistne"
    }
  }, [_vm._v(_vm._s(_vm.form.lastYearExpenses ? "Mesačné poistné" : "Zaplatené poistné za rok") + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.szco_rocne_poistne,
      expression: "form.szco_rocne_poistne",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "poistne",
      "data-name": "poistne",
      "id": "poistne"
    },
    domProps: {
      "value": _vm.form.szco_rocne_poistne
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "szco_rocne_poistne", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), _vm.form.lastYearExpenses !== 'other' ? _c('div', {
    staticClass: "field-source"
  }, [_vm.form.lastYearExpenses ? [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" v aktuálnom predpise Sociálnej poisťovne a zdravotnej poisťovne; zadajte ich mesačný súčet. ")] : [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" VI. oddiel, údaj „Preukázateľne zaplatené poistné“ pod tabuľkou č. 1. Kontrola: Príloha č. 4, riadok 11 (sociálne) + riadok 13 (zdravotné poistenie). ")]], 2) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zakladDane"
    }
  }, [_vm._v("Základ dane")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.taxBase,
      expression: "taxBase",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "zakladDane",
      "data-name": "zakladDane",
      "id": "zakladDane"
    },
    domProps: {
      "value": _vm.taxBase
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.taxBase = _vm._n($event.target.value);
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(3), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "danZPrijmu"
    }
  }, [_vm._v("Daň")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.incomeTax,
      expression: "form.incomeTax",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "name": "danZPrijmu",
      "data-name": "danZPrijmu",
      "id": "danZPrijmu"
    },
    domProps: {
      "value": _vm.form.incomeTax
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "incomeTax", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm._m(4), _vm._m(5), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: _vm.ico,
      expression: "ico",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "minlength": "8",
      "name": "icoZamestnavatel",
      "data-name": "Typ Pr Jmu 2",
      "placeholder": "",
      "id": "Typ-pr-jmu-2"
    },
    domProps: {
      "value": _vm.ico
    },
    on: {
      "change": [function ($event) {
        _vm.ico = $event.target.value;
      }, _vm.initializeEmployer]
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Sídlo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employerDetail.slovensko_digital_response.formatted_address,
      expression: "employerDetail.slovensko_digital_response.formatted_address"
    }],
    staticClass: "input-color-disabled text-input w-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "maxlength": "256",
      "name": "sidlo",
      "data-name": "sidlo",
      "placeholder": "",
      "id": "sidlo"
    },
    domProps: {
      "value": _vm.employerDetail.slovensko_digital_response.formatted_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.employerDetail.slovensko_digital_response, "formatted_address", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.podnikanieOd,
      expression: "form.podnikanieOd"
    }],
    staticClass: "text-input w-input date-input required",
    attrs: {
      "type": "date",
      "max": _vm.getTodayDate(),
      "maxlength": "256",
      "name": "podnikamOd",
      "data-name": "podnikamOd",
      "id": "podnikamOd",
      "required": ""
    },
    domProps: {
      "value": _vm.form.podnikanieOd
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "podnikanieOd", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "dropdown-input-custom rest-input required"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'tradesman_odvetvie',
      "init-value": _vm.form.odvetvie,
      "options": _vm.formTemplate.zamestnavatel_odvetvie.choices,
      "normal": "",
      "name": 'Odvetvie',
      "required": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'odvetvie');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input",
    staticStyle: {
      "margin-top": "17px"
    }
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'tradesman_komora',
      "init-value": _vm.form.komora,
      "options": _vm.formTemplate.komora.choices,
      "normal": "",
      "name": 'Komora'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'komora');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input",
    staticStyle: {
      "margin-top": "17px"
    }
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'tradesman_prechod_tpp',
      "init-value": _vm.form.prechod_zivnost_tpp_poslednych_6m,
      "options": [{
        display_name: 'áno',
        value: true
      }, {
        display_name: 'nie',
        value: false
      }],
      "normal": "",
      "name": 'Prechod zo živnosti na zamestnanie'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'prechod_zivnost_tpp_poslednych_6m');
      }
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "text-small light"
  }, [_vm._v("Údaje pre výpočet priemerného mesačného príjmu zadávajte za posledné ukončené účtovné obdobie. Viac o tom ako čítať daňové priznanie nájdete "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.bankari.sk/ako-na-to/hypoteka-pre-zivnostnikov-citanie-danoveho-priznania",
      "target": "_blank"
    }
  }, [_vm._v("TU")]), _vm._v(".")]), _c('div', {
    staticClass: "form-source-note"
  }, [_vm._v(" Odkazy na riadky nižšie platia pre daňové priznanie FO typ B za rok 2025 (DPFOBv25). ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" VI. oddiel, riadok 39 – príjmy prenesené z tabuľky č. 1, stĺpec 1, riadok 10. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" VI. oddiel, voľba pod tabuľkou č. 1. Paušálne výdavky sú označené ako „výdavky percentom z príjmov“; inak zvoľte reálne výdavky. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" VI. oddiel, riadok 45 – čiastkový základ dane z príjmov podľa § 6 ods. 1 a 2. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "field-source"
  }, [_c('strong', [_vm._v("Kde údaj nájdete:")]), _vm._v(" X. oddiel, riadok 116 – daňová povinnosť pred odpočítaním daňového bonusu. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "text-small light"
  }, [_vm._v(" Údaje o živnosti overíte na "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.zrsr.sk/default.aspx",
      "target": "_blank"
    }
  }, [_vm._v("zrsr.sk")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Typ-pr-jmu-2"
    }
  }, [_vm._v("IČO "), _c('span', {
    staticClass: "pop-300"
  }, [_vm._v("(údaje sa doplnia automaticky)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "podnikamOd"
    }
  }, [_vm._v("Podnikám "), _c('strong', [_vm._v("od")])]);

}]

export { render, staticRenderFns }